import { OtlpHttpTransport } from '@grafana/faro-transport-otlp-http';

export class OtlpHttpTransportRum extends OtlpHttpTransport {
  constructor(options) {
    super(options);
  }

  async send(items) {
    const enrichedItems = items.map((item) => {
      if (item.type === 'measurement') {
        const payload = item.payload;
        const values = payload.values;
        const keys = Object.keys(values);

        if (keys.length > 1) {
          const enrichedContext = { ...(payload.context || {}) };
          const primaryKey = keys[0];

          for (const [key, value] of Object.entries(values)) {
            if (key !== primaryKey) {
              enrichedContext[key] = String(value);
            }
          }

          return {
            ...item,
            payload: { ...payload, context: enrichedContext },
          };
        }
      }
      return item;
    });

    return super.send(enrichedItems);
  }
}